import { Box } from '@mui/material';
import useIsUserPremium from '@/DesignSystem/hooks/useIsUserPremium';
import useIsProduction from '@/DesignSystem/hooks/useIsProduction';
import { hbAdComponents, HbAdType } from '../hb-agency/hb-ad';

const Placement200Component = () => {
    const isPremium = useIsUserPremium();
    const isProduction = useIsProduction();

    if (isPremium || !isProduction) return null;

    return (
        <Box className="placement-ad-template">{hbAdComponents[HbAdType.FOOTER_MOBILE_LEADERBOARD_2]}</Box>
    );
};

export default Placement200Component;
